export interface DigitealValidateDocument_WarningError {
    id: string,
    fieldName: string,
    location: string,
    description: string,
    level: string,
    test: string,
    linkedExceptionMessage: string,
}
export type DigitealValidateDocument_ValidationResultStatus = "OK" | "WARNING" | "ERROR";
export interface DigitealValidateDocument_ValidationResult {
    specVersion: string,
    status: DigitealValidateDocument_ValidationResultStatus,
    errors: DigitealValidateDocument_WarningError[],
    warnings: DigitealValidateDocument_WarningError[],
}
export interface DigitealValidateDocumentResp{
    type: string,
    fullType: string,
    currentSpecValidationResult: DigitealValidateDocument_ValidationResult,
    futureSpecValidationResult: DigitealValidateDocument_ValidationResult,

}
//export const DigitealValidateDocument = async (ubl: Blob): Promise<DigitealValidateDocumentResp | null> => {
//    if (!ubl) return null;

//    const formData = new FormData(); formData.append("file", ubl); // adjust field name if required by API

//    console.log(ubl);
//    console.log(formData);
//    return null;
//    return fetch(`https://app.digiteal.eu/api/v1/peppol/public/validate-document`, {
//        method: "post",
//        headers: {
//            accept: "application/json"
//        },
//        body: formData,
//    })
//        .then(response => {
//            if (response.status !== 200) {
//                return null;
//            }
//            return response.json() as Promise<DigitealValidateDocumentResp>;
//        })
//        .then(data => {
//            return data;
//        });
//};
export const DigitealValidateDocument = async (token: string, Invoiceid: string): Promise<DigitealValidateDocumentResp | undefined | null> => {
    if (!Invoiceid || !token) return null;

    return fetch(`api/Invoices/` + Invoiceid + "/ValidateUBLInvoice", {
        method: "get",
        headers: {
            "Content-Type": "application/json",
            authorization: "bearer " + token,
        },
        mode: "cors",
        cache: "default",
    })
        .then(response => {
            if (response.status === 403) {
                return null;
            }
            else if (response.status === 404 || response.status === 204) {
                return undefined;
            }
            return response.json() as Promise<DigitealValidateDocumentResp>;
        })
        .then(data => {
            return data;
        });
};
